export default {

    // UAT  Staging Environment
    //url:"https://uatymgit-airhub.online/airhub/", 
    //s3bucket: "https://media.airhub.ai/",
	
	
	// UAT  testing Environment
   //url:"http://3.23.254.179:8085/airhub/",   
   //s3bucket: "https://media.airhub.ai/", 


//    s3bucket: "https://s3-ap-southeast-1.amazonaws.com/uat.media/",

   //Production Environement
   url:"https://airhub.ai:8443/airhub/", 
   s3bucket: "https://media.airhub.ai/",    
   
   //Local Environment
   //url:"http://localhost:8085/airhub/", 
   //s3bucket: "https://media.airhub.ai/",   
//    s3bucket: "https://airhub-uat.s3-ap-southeast-1.amazonaws.com/",

   SIAASignupLink:'https://docs.google.com/forms/d/1ERgZeWkddwpWs1Fqfyy8L25jEd04QxWNlsl5eh_e5OY/viewform?ts=5d2d98a7&edit_requested=true" className="btn-md btn btn-primary"',
   cat_industry :1,
   cat_business:2,
   cat_country :3,
   cat_offering_subtype:4,
   cat_application:5,
   cat_offering:6,
   user_active : 1,
   user_suspended :2,
   admin :1,
   contentmanager :2,
   status_pending:1,
   status_approval:2,
   status_rejected:3,
   status_needclarification:4,
   status_resubmitted:5,
   status_draft:8,
   userrole_admin :1,
   userrole_partner:2,
   userrole_superadmin:0,
   time_interval : 1000*60*360,//360 minutes
   pageSize:15,
   texteditor_config : {
   placeholder : "About Company",
    removePlugins : ['Heading', 'Bold','Italic','Link','ImageUpload','Table','MediaEmbed'],
    tollbar :{
        items:[ 'BulletedList' , 'NumberedList'] }  
    },
    texteditor_offering_config : {
      placeholder : "Product & Services Description",
       removePlugins : ['Heading', 'Bold','Italic','Link','ImageUpload','Table','MediaEmbed'],
       tollbar :{
           items:[ 'BulletedList' , 'NumberedList'] }  
       },
    texteditor_ss1_config : {
         placeholder : "Challenges Encountered",
          removePlugins : ['Heading', 'Bold','Italic','Link','ImageUpload','Table','MediaEmbed'],
          tollbar :{
              items:[ 'BulletedList' , 'NumberedList'] }  
          },
     texteditor_ss2_config : {
            placeholder : "Solutions Adopted",
             removePlugins : ['Heading', 'Bold','Italic','Link','ImageUpload','Table','MediaEmbed'],
             tollbar :{
                 items:[ 'BulletedList' , 'NumberedList'] }  
             },
     texteditor_ss3_config : {
               placeholder : "Tangible Benefits",
                removePlugins : ['Heading', 'Bold','Italic','Link','ImageUpload','Table','MediaEmbed'],
                tollbar :{
                    items:[ 'BulletedList' , 'NumberedList'] }  
                },
     texteditor_ss4_config : {
                  placeholder : "Intangible Benefits",
                   removePlugins : ['Heading', 'Bold','Italic','Link','ImageUpload','Table','MediaEmbed'],
                   tollbar :{
                       items:[ 'BulletedList' , 'NumberedList'] }  
                   },
     meta_title: "SIAA AIRHUB : Automation,IoT,Robotics",
     meta_description :"SIAA AIRHUB : Automation,IoT,Robotics. Place for entrepreneurs, technologists and Venture Capitalists to collaborate and drive innovation and business in Automation, Internet-of-Things and Robotics (AIR)",
     meta_icon :"favicon-96x96.png",
     meta_keywords : "Automation, Iot, Robotics",
     google_analytics_tracking_id: 'G-N9Z1685WWD',
     google_analytics_proprty_id:'324881263',
     google_analytics_run_report:`https://analyticsdata.googleapis.com/v1beta/properties/324881263:runReport`
   
 }